import { FC, ReactNode } from 'react';
import OriginalReactMarkdown from 'react-markdown';

import { Markdown } from './Markdown';

const renderers = {
  paragraph: ({ index, children }) => {
    return <p className={index === 0 ? 'first-markdown-element' : ''}>{children}</p>;
  },
  list: ({ index, children }) => {
    return <ul className={index === 0 ? 'first-markdown-element' : ''}>{children}</ul>;
  },
};

export const ClampedMarkdown: FC<OriginalReactMarkdown.ReactMarkdownProps & { children?: ReactNode }> = ({
  source,
  ...restProps
}) => {
  return <Markdown source={source} includeNodeIndex renderers={renderers} {...restProps} />;
};
